module.exports = __webpack_public_path__ + "img/logo.d3453e88.png";